import { setMeasureTelemetry } from "@acme/measure/telemetry";
import * as Sentry from "@sentry/nextjs";
import { trackEvent } from "./gtm";

setMeasureTelemetry({
  track: (event, data) => trackEvent(event, data),
  reportError: (error, tags) => {
    if (tags === undefined) {
      Sentry.captureException(error);
      return;
    }
    Sentry.captureException(error, { captureContext: { tags } });
  },
});
